module.exports = __webpack_public_path__ + "img/background.bdf91cf1.png";